import { render, staticRenderFns } from "./CarAccidentList.vue?vue&type=template&id=e7fde6b4"
import script from "./CarAccidentList.vue?vue&type=script&lang=js"
export * from "./CarAccidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports